import React from 'react';

export function Card({ className = '', children, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div 
      className={`bg-[var(--color-csai-surface)] rounded-xl p-4 sm:p-6 shadow-md ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}
